import React, {useEffect, useState, useRef} from 'react';
import styled from "styled-components";
import {realtorsAroundProperty} from "@models/property";
import ButtonBase from "@atoms/button.base";
import Icon from "@atoms/icon";
import {getPropertyContactInfo} from "@models/property";
import {isEmpty} from "@helpers/helpers";
import ShowContactContent from "./contact/content";
import ShowContactAssignedRealtors from "./contact/assigned_realtors";
import ContactInfoModal from "@organisms/contact_info/contact_modal";
import Skeleton from "react-loading-skeleton";
import {handleFixedButtonShowAndHide} from "./helpers";
import {checkPropertyIsAssignedAndOwner} from "../helpers/property_helpers";
import {getExpertNumberForRequestForm} from "../crm_requests/helpers";
import {formatPhoneNumber} from "../../../helpers/numbers";
import Divider from "../../../atoms/divider";
import DelNormalIcon from "@icons/del-normal.svg";

function Contact({property, perContact, setPerContact, setQuickContact, setShowLoginWithCallback}) {
    const contactRef = useRef('');
    const fixButtonRef = useRef('');
    const assignedAndIsOwner = checkPropertyIsAssignedAndOwner(property);
    const [contactInfo, setContactInfo] = useState(property.contact_info);
    const [realtors, setRealtors] = useState([]);
    const [notAssignedRealtors, setNotAssignedRealtors] = useState(true);

    useEffect(() => {
        if (!isEmpty(property) && !property.archived) {
            if (isEmpty(contactInfo) && !assignedAndIsOwner) {
                getPropertyContact(property.id);
            } else if (assignedAndIsOwner) {
                setNotAssignedRealtors(false);

                realtorsAroundProperty(property.id).then(result => {
                    if (result.realtors.length > 0) {
                        setRealtors(result.realtors)
                    } else {
                        getPropertyContact(property.id);
                    }
                })
            }
        }
    }, []);

    function getPropertyContact(property_id) {
        getPropertyContactInfo(property_id).then(result => {
            setContactInfo(result.contactInfo);
            setNotAssignedRealtors(true);
        }).catch(error => {
            console.log(error)
        });
    }

    const handleScroll = () => {
        if (!isEmpty(contactRef.current) && !isEmpty(fixButtonRef.current)) {
            handleFixedButtonShowAndHide(contactRef.current.offsetParent.offsetTop, fixButtonRef)
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });

    const showRequestModalForm = () => {
        setPerContact({
            show: true,
            property_id: property.id,
            city_id: property.city_id,
            district_id: property.district_id,
            realtor_id: null,
            agency_id: null,
            isAssignedProperty: assignedAndIsOwner,
            isOnList: false,
            exists_in_kanban: property.request_contact,
            isBadeSaba: false,
        })
    };

    const expertTelNumber = getExpertNumberForRequestForm(property.city_id, property.district_id);

    return (
        <Card ref={contactRef} className={"p-32 d-flex flex-column align-items-center text-center rounded-16 " + ((!isEmpty(property) && property.archived) ? "archive-property" : '')}>
            <ContactInfoModal
                perContact={perContact}
                setPerContact={setPerContact}
                setQuickContact={!assignedAndIsOwner ? setQuickContact : null}
                setShowLoginWithCallback={setShowLoginWithCallback}
            />

            {
                (!isEmpty(property) && property.request_contact) ?
                    <React.Fragment>
                        <div className="h2 mb-16">این ملک رو پسندیدید؟</div>
                        <div className="text-center">
                            <span className="d-block">
                                {
                                    (!isEmpty(expertTelNumber)) ?
                                        'با کارشناس این ملک تماس بگیرید.'
                                        :
                                        'با ثبت درخواست خرید، کارشناس این ملک با شما تماس خواهد گرفت.'
                                }
                            </span>

                            {
                                (!isEmpty(expertTelNumber)) ?
                                    <a href={"tel:" + expertTelNumber} className="h2 mt-8 d-block text-black"> {formatPhoneNumber(expertTelNumber)} </a>
                                    : ''
                            }
                        </div>

                        {
                            (!isEmpty(expertTelNumber)) ?
                                <Divider className="mt-32 mb-24 position-relative">
                                    <DividerSpan>یا</DividerSpan>
                                </Divider>
                                : ''
                        }

                        <ButtonBase
                            color="secondary"
                            block
                            className="mt-24"
                            onClick={showRequestModalForm}
                        >
                            درخواست خرید
                        </ButtonBase>
                    </React.Fragment>
                    :
                    (
                        (assignedAndIsOwner && realtors.length) ?
                            <ShowContactAssignedRealtors
                                realtors={realtors}
                                city_id={property.city_id}
                                setPerContact={setPerContact}
                            />
                            :
                            (
                                (!isEmpty(contactInfo) && !property.archived && notAssignedRealtors) ?
                                    <ShowContactContent
                                        contactInfo={contactInfo}
                                        perContact={perContact}
                                        property={property}
                                        fixButtonRef={fixButtonRef}
                                        setPerContact={setPerContact}
                                    />
                                    :
                                    (
                                        (!isEmpty(property) && property.archived) ?
                                            <div className="archive-property-contact w-100 h-100 rounded-16 bg-gray100 d-flex flex-column align-items-center justify-content-center">
                                                <Icon width={96}><DelNormalIcon/></Icon>
                                                <span className="text-primary h2 mt-16">ملک آرشیوی</span>
                                            </div>
                                            :
                                            (
                                                <div className="w-100 bg-white text-center">
                                                    <Skeleton width={88} height={88} circle={true}/>

                                                    <div className="mt-16 d-flex justify-content-center flex-column">
                                                        <Skeleton width={'70%'}/>
                                                        <Skeleton width={'50%'}/>
                                                    </div>

                                                    <div className="">
                                                        <Skeleton width={'70%'}/>
                                                    </div>

                                                    <div className=" mt-16">
                                                        <Skeleton width={'100%'} height={48}/>
                                                    </div>
                                                </div>
                                            )
                                    )
                            )
                    )
            }
        </Card>
    )
}

export default React.memo(Contact);

// styles
const Card = styled.div`
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.12);
  background-color: ${props => props.theme.white};
  border: 1px solid ${props => props.theme.gray200};

  @media (max-width: ${props => props.theme.screenSmMax}) {
    margin-top: 0;
  }

  &.archive-property {
    position: relative;
    box-shadow: none;
    min-height: 300px;

    .archive-property-contact {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`;

const PropertyRequestCard = styled.div`
    box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.12);
    background-color: ${props => props.theme.white};

    @media (max-width: ${props => props.theme.screenSmMax}) {
        margin-top: 0;
    }
`;

const DividerSpan = styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: #fff;
    padding: 0 24px;
    transform: translate(-50%, -50%);
`;